let prevScrollposHeaderHidden = window.pageYOffset;

function switchHeader() {
    const currentScrollPos = window.pageYOffset;
    const directionUp = prevScrollposHeaderHidden > currentScrollPos;

    if (directionUp || currentScrollPos <= 120) {
        document.querySelector('.header').classList.remove('header--hidden');
    } else {
        if (!document.body.classList.contains('-search-open')) {
            document.querySelector('.header').classList.add('header--hidden');
        }
    }
    prevScrollposHeaderHidden = currentScrollPos;
}

// Hide and show 'Call-To-Actions'-menu on the bottom for mobile devices
const mobileBottomBtn = document.querySelector('.mobile-bottom-menu');
var showScroll = function () {
    var y = window.scrollY;

    if (window.pageYOffset < y || y > 65) {
        mobileBottomBtn.classList.add('show');
        mobileBottomBtn.style.visibility = 'visible';
    } else {
        mobileBottomBtn.classList.remove('show');
        mobileBottomBtn.style.visibility = 'hidden';
    }
};

window.addEventListener('scroll', showScroll, { passive: true });
window.addEventListener('scroll', switchHeader, { passive: true });

// Add fixed class to element at top of page on load and remove on scroll
const headerEl = document.querySelector('.header');

if (headerEl.offsetTop === 0 && document.documentElement.scrollTop === 0) {
    headerEl.classList.add('header--on-top');
}

let prevScrollposHeaderOnTop = window.pageYOffset;
function fixHeaderOnScroll() {
    const currentScrollPos = window.pageYOffset;
    const directionUp = prevScrollposHeaderOnTop > currentScrollPos;

    if (currentScrollPos === 0) {
        headerEl.classList.add('header--on-top');
    } else if (directionUp) {
        headerEl.classList.remove('header--on-top');
    }

    prevScrollposHeaderOnTop = currentScrollPos;
}

window.addEventListener('scroll', fixHeaderOnScroll, { passive: true });
